import * as React from "react";
const SvgGrabFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6m0 14a3 3 0 1 1 0 6 3 3 0 0 1 0-6m0-7a3 3 0 1 1 0 6 3 3 0 0 1 0-6m8-7a3 3 0 1 1 0 6 3 3 0 0 1 0-6m0 14a3 3 0 1 1 0 6 3 3 0 0 1 0-6m0-7a3 3 0 1 1 0 6 3 3 0 0 1 0-6", clipRule: "evenodd" }));
export default SvgGrabFill;
